import React from 'react';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { Box, Video } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Overlay = styled.div.withConfig({
  displayName: "VideoModal__Overlay",
  componentId: "sc-xl0orb-0"
})(["background-color:", ";position:fixed;z-index:999;left:0;right:0;top:0;bottom:0;", " transition:", "ms ease;transition-property:opacity,visibility;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dimmedBlue;
}, function (_ref2) {
  var state = _ref2.state;
  return state === 'entering' || state === 'entered' ? "\n    opacity: 1;\n    visibility: visible;\n  " : "\n    opacity: 0;\n    visibility: hidden;\n  ";
}, function (_ref3) {
  var duration = _ref3.duration;
  return duration;
});
var Container = styled(Box).attrs({
  $styles: {
    width: ['90%', 1024],
    height: ['auto', 576]
  }
}).withConfig({
  displayName: "VideoModal__Container",
  componentId: "sc-xl0orb-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);
var CloseButton = styled(Box).attrs({
  $styles: {
    width: [40],
    height: [40],
    top: [-40],
    right: [-40],
    display: ['none', 'block']
  }
}).withConfig({
  displayName: "VideoModal__CloseButton",
  componentId: "sc-xl0orb-2"
})(["position:absolute;cursor:pointer;transform:rotate(45deg);&::before{content:'';background:", ";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);", ";}&::after{content:'';background:", ";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primaryWhite;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.normalizeStyles({
    width: [30],
    height: [2]
  });
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.primaryWhite;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.normalizeStyles({
    width: [2],
    height: [30]
  });
});
var CloseButtonMobile = styled(CloseButton).attrs({
  $styles: {
    top: [25],
    right: [25],
    display: ['block', 'none']
  }
}).withConfig({
  displayName: "VideoModal__CloseButtonMobile",
  componentId: "sc-xl0orb-3"
})([""]);
var duration = 250;

var VideoModal = function VideoModal(props) {
  return /*#__PURE__*/_jsx(Transition, {
    "in": props.show,
    timeout: duration,
    children: function children(state) {
      return /*#__PURE__*/_jsxs(Overlay, {
        state: state,
        duration: duration,
        children: [/*#__PURE__*/_jsx(CloseButtonMobile, {
          onClick: function onClick() {
            if (props.onClose) props.onClose();
          }
        }), /*#__PURE__*/_jsxs(Container, {
          children: [/*#__PURE__*/_jsx(CloseButton, {
            onClick: function onClick() {
              if (props.onClose) props.onClose();
            }
          }), props.show && /*#__PURE__*/_jsx(Video, {
            id: props.videoId,
            controls: true
          })]
        })]
      });
    }
  });
};

export default VideoModal;